import { cast, types } from 'mobx-state-tree';
import { currentUserQuery } from '@app-types/graphql-types';
import { CourseCoordinator } from '@models/CourseCoordinator';
import { Route } from '@models/Route';

export const User = types
  .model('UserModel', {
    id: '',
    firstName: '',
    lastName: '',
    email: types.maybeNull(types.string),
    firebaseUID: '',
    departmentId: '',
    userRoles: types.array(types.string),
    routes: types.optional(types.array(Route), []),
    courseCoordinators: types.optional(types.array(CourseCoordinator), []),
    initialTourFollowed: false,
    profilePicture: types.maybeNull(types.string),
  })
  .actions((self) => ({
    addUser(
      id: string,
      firstName: string,
      lastName: string,
      email: string | null,
      firebaseUID: string,
      departmentId: string,
      userRoles: currentUserQuery['current_user'][0]['user_user_roles_user_roles'],
      routes: currentUserQuery['current_user'][0]['current_user_routes_route'],
      courseCoordinators: currentUserQuery['current_user'][0]['course_coordinators'],
      initialTourFollowed: boolean,
      profilePicture: string,
    ) {
      self.initialTourFollowed = initialTourFollowed;
      self.id = id;
      self.firstName = firstName;
      self.lastName = lastName;
      self.email = email;
      self.firebaseUID = firebaseUID;
      self.departmentId = departmentId;
      self.userRoles = cast(userRoles.map((userRole) => userRole.user_role.name || ''));
      self.profilePicture = profilePicture;

      courseCoordinators.forEach((courseCoordinator) => {
        self.courseCoordinators.push({
          batchId: courseCoordinator.batchId,
          semesterId: courseCoordinator.semesterId,
        });
      });

      routes.forEach((route) => {
        let parent;

        if (route.current_user_route.current_user_route_parent) {
          parent = {
            id: route.current_user_route.current_user_route_parent.id,
            name: route.current_user_route.current_user_route_parent.name,
          };
        }

        self.routes.push({
          id: route.current_user_route.id,
          name: route.current_user_route.name,
          componentName: route.current_user_route.componentName,
          path: route.current_user_route.path,
          iconName: route.current_user_route.iconName,
          dummy: route.current_user_route.dummy,
          showInMenu: route.current_user_route.showInMenu,
          order: route.current_user_route.order,
          parent: parent || null,
        });
      });
    },
  }));
